<template>
  <v-dialog v-model="dialogImportLoading.open" persistent content-class="small">
    <v-card>
      <v-card-text class="text-center">
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <p>
                Importing data...<br />
                <b>Do not close this window</b>
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="80"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogImportLoadingCampaignVoice',
  props: {
    dialogImportLoading: Object
  }
}
</script>
